import AuthenticatedWrapper from './Authenticated';
import InterstitialWrapper from './Interstitial';
import PublicWrapper from './Public';

export const AUTHENTICATED = 'AUTHENTICATED';
export const UNAUTHENTICATED = 'UNAUTHENTICATED';
export const INTERSTITIAL = 'INTERSTITIAL';

type BrandingStyle =
  typeof AUTHENTICATED | typeof UNAUTHENTICATED | typeof INTERSTITIAL;

const useWrapper = (type: BrandingStyle) => {
  switch (type) {
    case AUTHENTICATED:
      return AuthenticatedWrapper;
    case UNAUTHENTICATED:
      return PublicWrapper;
    case INTERSTITIAL:
      return InterstitialWrapper;
    default:
      return PublicWrapper;
  }
};

export const withBranding =
  (type: BrandingStyle) => (Component: any) => (props: any) => {
    const Wrapper = useWrapper(type);
    return (
      <Wrapper>
        <Component {...props} />
      </Wrapper>
    );
  };
